import mitt from 'mitt';
import { MonitorEvents } from "./MonitorEvents";
import { ModeCompareEvents } from "./ModeCompareEvents";
import { DisasterEvents } from "./DisasterEvents";
import { IntelligentGridEvents } from "./IntelligentGridEvents";
import { ShortImpendingEvents } from "./ShortImpendingEvents";
import { FactsMonitorEvents } from "./FactsMonitorEvent";
import { DecisionServiceEvents } from "./DecisionService";
import { CommonToolsEvents } from "./CommonToolsEvents";
import { RiskWarningEvent } from './RiskWarningEvent';
import { ExposureEvents } from './ExposureEvents';

const Bus_AppEvents = {
    /** 智能示警相关消息 */
    Monitor: mitt<MonitorEvents>(),
    /** 模式对比相关消息 */
    ModeCompare: mitt<ModeCompareEvents>(),
    /** 风险产品制作 */
    DisasterEvents: mitt<DisasterEvents>(),
    /** 智能网格 */
    IntelligentGrid: mitt<IntelligentGridEvents>(),
    /** 短临预警 */
    ShortImpend: mitt<ShortImpendingEvents>(),
    /** 实况监测的消息 */
    FactsMonitor: mitt<FactsMonitorEvents>(),
    /** 决策服务 */
    DecisionService: mitt<DecisionServiceEvents>(),
    /** 常用工具 */
    CommonTools: mitt<CommonToolsEvents>(),
    /** 风险预警 */
    RiskWarning: mitt<RiskWarningEvent>(),
    /** 承灾体矩阵状态 */
    ExposureElementZone: mitt<ExposureEvents>()

}
export default Bus_AppEvents
